document.addEventListener("DOMContentLoaded", () => {
  // DOM elements
  const elements = {
    giftCheckbox: document.getElementById("gift-toggle"),
    spinner: document.getElementById("giftflow-spinner"),
    noteCheckbox: document.getElementById("handwritten-note-toggle"),
    giftboxCheckbox: document.getElementById("giftbox-toggle"),
    ribbonCheckbox: document.getElementById("ribbon-toggle"),
    giftNoteTextarea: document.getElementById("handwritten-note"),
    ribbonText: document.getElementById("custom-ribbon"),
    cartButton: document.getElementById("cart-drop"),
    shipButton: document.getElementById("shipping"),
    clearButton: document.getElementById("clear-cart"),
    textareas: document.querySelectorAll(".gift-option-text"),
    giftFlow: document.querySelector(".gift-flow-cart"),
    checkboxes: document.querySelectorAll(".toggle-checkbox"),
    giftOptions: document.querySelectorAll(".gift-option-container"),
    giftingOptions: document.querySelector(".gift-flow-options"),
    giftingLoader: document.querySelector(".gifting-loader"),
    giftflowSummary: document.querySelector(".gift-flow-summary"),
    personalisations: document.querySelectorAll(
      ".gift-flow-cart .gift-flow-personalisations"
    ),
    bundles: document.querySelectorAll(".gift-flow-cart .gift-flow-bundle"),
    giftboxQuantity: document.getElementById("giftbox-quantity"),
    giftboxQuantityHidden: document.getElementById("giftbox-quantity-hidden"),

    // valentines
    vdayCheckbox: document.getElementById("vday-toggle"),
    vdayNoteText: document.getElementById("vday-handwritten-note"),
    vdayRibbonText: document.getElementById("vday-custom-ribbon"),
    vdayNoteCount: document.getElementById("vday-handwritten-note-count"),
    vdayRibbonCount: document.getElementById("vday-custom-ribbon-count"),

    // md25
    md25Checkbox: document.getElementById("md25-toggle"),
    md25NoteText: document.getElementById("md25-handwritten-note"),
    md25RibbonText: document.getElementById("md25-custom-ribbon"),
    // md25RibbonColour: document.getElementById("md25-ribbon-colour"),
    // md25ToteDesign: document.getElementById("md25-tote-design"),
    md25NoteCount: document.getElementById("md25-handwritten-note-count"),
    md25RibbonCount: document.getElementById("md25-custom-ribbon-count"),

    // fd25
    fd25Checkbox: document.getElementById("fd25-toggle"),
  };

  // Gifting Items - Variant IDs
  const variantIds = {
    giftNoteId: 45839006269699,

    ribbonId: 46116785717507,
    ribbonId2: 46116785750275,
    ribbonId3: 46116785783043,
    ribbonId4: 46116785815811,

    giftBoxId: 32395471257649,

    vdayPackageId: 46339477340419,
    md25PackageId: 46441091662083,

    fd25PackageId: 46822459900163,
  };

  // Gifting Items - Product Handles
  const handles = {
    note: "nab-gift-note",
    ribbon: "personalised-ribbon",
    box: "gift-box-1",
    valentines: "valentines-package",
    // md25: "others-day-gift-wrapping",
    // fd25: "fathers-day-patches",
  };

  // let notePrice;
  let ribbonPrice;
  let ribbonColour;
  let boxPrice;

  // show / hide spinner helper function
  function toggleSpinner(show) {
    if (show) {
      elements.spinner.style.display = "block"; // Show spinner
    } else {
      elements.spinner.style.display = "none"; // Hide spinner
    }
  }

  // Debounce helper function
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Fetch wrapper with error handling
  const fetchWithHandling = async (url, options) => {
    toggleSpinner(true);
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error(`Fetch failed: ${response.statusText}`);
      const jsonRes = await response.json();
      if (jsonRes.sections) {
        // console.log("jsonRes sections: ", jsonRes.sections);
        const elementToReplace = document.querySelector(".gift-js-contents");
        if (elementToReplace) {
          elementToReplace.innerHTML = await getInnerHtml(
            jsonRes.sections["gift-flow"],
            ".gift-js-contents"
          );
        }
        initialiseTooltips();
      }
      return jsonRes;
    } catch (error) {
      console.error(`Error during fetch: ${error.message}`);
      throw error;
    } finally {
      toggleSpinner(false);
    }
  };

  const getInnerHtml = async (html, selector) => {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  };

  // API functions
  const addProductToCart = async (variant) => {
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const formData = {
      items: [{ id: variant, quantity: 1 }],
      sections: "gift-flow",
    };
    await fetchWithHandling(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
  };

  const updateCartAttributes = async (attributes) => {
    const url = `${window.Shopify.routes.root}cart/update.js`;
    const update = await fetchWithHandling(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes }),
    });
    console.log("Cart attributes update: ", update);
  };

  const checkCartAttribute = async (attribute) => {
    const url = `${window.Shopify.routes.root}cart.js`;
    const data = await fetchWithHandling(url, { method: "GET" });
    return data.attributes ? data.attributes[attribute] : null;
  };

  // find the cart key of the item with the given variant ID
  const getItemKey = async (variantId) => {
    const url = `${window.Shopify.routes.root}cart.js`;
    const data = await fetchWithHandling(url, { method: "GET" });
    const item = data.items.find((item) => item.variant_id === variantId);
    return item ? item.key : null;
  };

  const updateItemQuantity = async (key, quantity) => {
    const url = `${window.Shopify.routes.root}cart/change.js`;
    await fetchWithHandling(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        quantity,
        sections: "gift-flow",
      }),
    });
  };

  const submitProperty = async (key, propertyName, propertyValue) => {
    // First, get current properties
    const currentProperties = (await getItemProperties(key)) || {};

    // Merge the new property with existing properties
    const updatedProperties = {
      ...currentProperties,
      [propertyName]: propertyValue,
    };

    const url = `${window.Shopify.routes.root}cart/change.js`;
    await fetchWithHandling(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        properties: updatedProperties,
        sections: "gift-flow",
      }),
    });
  };

  const getItemProperties = async (key) => {
    const url = `${window.Shopify.routes.root}cart.js`;
    const data = await fetchWithHandling(url, { method: "GET" });
    const item = data.items.find((item) => item.key === key);
    return item ? item.properties : null;
  };

  const getItemPrice = async (handle) => {
    const url = `${window.Shopify.routes.root}products/${handle}.js`;
    const data = await fetchWithHandling(url, { method: "GET" });

    // console.log("Product Data: ", data);

    return data.price_max / 100;
  };

  // Event Handlers
  const handleCheckboxChange = async (event, variantId) => {
    event.preventDefault();

    console.log("Checkbox change event: ", event);
    console.log("Variant ID: ", variantId);

    const {
      target: { id, checked },
    } = event;

    if (variantId && checked) await addProductToCart(variantId);

    if (id === "handwritten-note-toggle" && !checked) {
      elements.giftNoteTextarea.value = "";
      elements.giftNoteTextarea.parentElement.querySelector(
        ".gift-option-counter span"
      ).textContent = 0;
      const key = await getItemKey(variantIds.giftNoteId);
      if (key) await submitProperty(key, "Giftnote Text", "");
    }

    if (variantId && !checked) {
      const key = await getItemKey(variantId);
      if (key) await updateItemQuantity(key, 0);
    }
  };

  const handleRibbonCheckboxChange = async (event, variantId) => {
    event.preventDefault();
    console.log("Checkbox change detected:", event);

    const {
      target: { id, checked },
    } = event;

    if (checked) {
      console.log("Checkbox checked. Adding variant:", variantId);
      if (variantId) await addProductToCart(variantId);
    } else {
      console.log("Checkbox unchecked. Attempting to remove ribbon variants.");

      const ribbonVariantIds = [
        variantIds.ribbonId,
        variantIds.ribbonId2,
        variantIds.ribbonId3,
        variantIds.ribbonId4,
      ];

      for (const id of ribbonVariantIds) {
        const ribbonKey = await getItemKey(id);
        console.log("Checking ribbon variant ID:", id, "Key:", ribbonKey);
        if (ribbonKey) {
          console.log("Removing variant with key:", ribbonKey);
          await updateItemQuantity(ribbonKey, 0);
        }
      }

      elements.ribbonText.value = "";
      elements.ribbonText.parentElement.querySelector(
        ".gift-option-counter span"
      ).textContent = 0;
    }

    if (id === "handwritten-note-toggle" && !checked) {
      console.log("Clearing handwritten note text.");
      elements.giftNoteTextarea.value = "";
      elements.giftNoteTextarea.parentElement.querySelector(
        ".gift-option-counter span"
      ).textContent = 0;
      const key = await getItemKey(variantIds.giftNoteId);
      if (key) await submitProperty(key, "Giftnote Text", "");
    }
  };

  const handleGiftNoteInput = debounce(async (event) => {
    // await updateCartAttributes({ "Gift Note": event.target.value });
    const key = await getItemKey(variantIds.giftNoteId);
    if (key) await submitProperty(key, "Giftnote Text", event.target.value);
  }, 300);

  const handleRibbonTextInput = debounce(async (event) => {
    // Array of all ribbon variant IDs
    const ribbonVariantIds = [
      variantIds.ribbonId,
      variantIds.ribbonId2,
      variantIds.ribbonId3,
      variantIds.ribbonId4,
    ];

    // Find the ribbon key in the cart for the selected ribbon variant
    let ribbonKey;
    for (const id of ribbonVariantIds) {
      ribbonKey = await getItemKey(id);
      if (ribbonKey) break; // Exit the loop once a matching ribbon key is found
    }

    // If a matching ribbon key is found, update its properties with the ribbon text
    if (ribbonKey) {
      await submitProperty(ribbonKey, "Ribbon Text", event.target.value);
    }
  }, 300);

  const handleRibbonColorChange = async (event) => {
    const selectedColor = event.target.value;
    ribbonColour = selectedColor;
    console.log("Ribbon color changed to:", ribbonColour); // Confirm ribbonColour is set

    let selectedVariantId;

    // Map the selected ribbon color to the appropriate variant ID
    switch (selectedColor) {
      case "Neon green":
        selectedVariantId = variantIds.ribbonId;
        break;
      case "Pink":
        selectedVariantId = variantIds.ribbonId2;
        break;
      case "Cream":
        selectedVariantId = variantIds.ribbonId3;
        break;
      case "Black":
        selectedVariantId = variantIds.ribbonId4;
        break;
      default:
        console.log("No matching color found for selected ribbon color.");
        return; // Exit if no matching color
    }

    // Save the current ribbon text value
    const ribbonTextValue = elements.ribbonText.value;
    console.log("Saving ribbon text value:", ribbonTextValue);

    // Array of all ribbon variant IDs
    const ribbonVariantIds = [
      variantIds.ribbonId,
      variantIds.ribbonId2,
      variantIds.ribbonId3,
      variantIds.ribbonId4,
    ];

    // Remove all instances of ribbon variants from the cart
    for (const variantId of ribbonVariantIds) {
      let ribbonKey;
      do {
        ribbonKey = await getItemKey(variantId); // Find if this variant is in the cart
        if (ribbonKey) {
          console.log("Removing ribbon variant with key:", ribbonKey);
          await updateItemQuantity(ribbonKey, 0); // Remove the variant
        }
      } while (ribbonKey); // Repeat until no more instances of this variant ID are found
    }

    // Add the new ribbon variant with the saved ribbon text value
    if (selectedVariantId) {
      await addProductToCart(selectedVariantId);

      // Wait briefly to ensure the new item is added, then update its properties
      const newRibbonKey = await getItemKey(selectedVariantId);
      if (newRibbonKey && ribbonTextValue) {
        await submitProperty(newRibbonKey, "Ribbon Text", ribbonTextValue);
      }
    }
  };

  const handleGiftboxQuantityChange = async (event) => {
    const quantity = parseInt(event.target.value, 10);
    elements.giftboxQuantityHidden.value = quantity;
    const key = await getItemKey(variantIds.giftBoxId);
    if (key) {
      await updateItemQuantity(key, quantity);
    } else if (quantity > 0) {
      await addProductToCart(variantIds.giftBoxId);
      const newKey = await getItemKey(variantIds.giftBoxId);
      if (newKey) {
        await updateItemQuantity(newKey, quantity);
      }
    }
  };

  const handleGiftboxQuantityIncrement = async (increment) => {
    let quantity = parseInt(elements.giftboxQuantity.value, 10);
    quantity = isNaN(quantity) ? 0 : quantity + increment;
    quantity = Math.max(1, quantity); // Ensure quantity is at least 1
    elements.giftboxQuantity.value = quantity;
    elements.giftboxQuantityHidden.value = quantity;
    const key = await getItemKey(variantIds.giftBoxId);
    if (key) {
      await updateItemQuantity(key, quantity);
    } else if (quantity > 0) {
      await addProductToCart(variantIds.giftBoxId);
      const newKey = await getItemKey(variantIds.giftBoxId);
      if (newKey) {
        await updateItemQuantity(newKey, quantity);
      }
    }
  };

  const getGiftboxQuantity = async () => {
    const key = await getItemKey(variantIds.giftBoxId);
    if (key) {
      const url = `${window.Shopify.routes.root}cart.js`;
      const data = await fetchWithHandling(url, { method: "GET" });
      const item = data.items.find((item) => item.key === key);
      if (item) {
        elements.giftboxQuantity.value = item.quantity;
        elements.giftboxQuantityHidden.value = item.quantity;
      }
    }
  };

  const toggleTextareas = () => {
    elements.checkboxes.forEach((checkbox, index) => {
      // console.log("Checkbox:", checkbox);
      elements.giftOptions[index].style.display = checkbox.checked
        ? "block"
        : "none";
    });
  };

  const updateCounter = (event) => {
    event.target.parentElement.querySelector(
      ".gift-option-counter span"
    ).textContent = event.target.value.length;
  };

  const getTextareaContent = async () => {
    const giftNoteKey = await getItemKey(variantIds.giftNoteId);
    const vdayKey = await getItemKey(variantIds.vdayPackageId);
    const md25Key = await getItemKey(variantIds.md25PackageId);

    // Array to hold all ribbon variant IDs
    const ribbonVariantIds = [
      variantIds.ribbonId,
      variantIds.ribbonId2,
      variantIds.ribbonId3,
      variantIds.ribbonId4,
    ];

    // Find the first ribbon key in the cart that matches any ribbon variant ID
    let ribbonKey;
    for (const id of ribbonVariantIds) {
      ribbonKey = await getItemKey(id);
      if (ribbonKey) break; // Exit the loop as soon as we find a matching key
    }

    // Retrieve properties for both the gift note, ribbon, valentines package, and mother's day package (if they exist)
    const [giftTextValue, ribbonTextValue, vdayValue, md25Value] =
      await Promise.all([
        giftNoteKey ? getItemProperties(giftNoteKey) : null,
        ribbonKey ? getItemProperties(ribbonKey) : null,
        vdayKey ? getItemProperties(vdayKey) : null,
        md25Key ? getItemProperties(md25Key) : null,
      ]);

    // Update the gift note textarea if a gift note exists in the cart
    if (giftTextValue && giftTextValue["Giftnote Text"]) {
      elements.giftNoteTextarea.value = giftTextValue["Giftnote Text"];
      elements.giftNoteTextarea.parentElement.querySelector(
        ".gift-option-counter span"
      ).textContent = giftTextValue["Giftnote Text"].length;
    }

    // Update the ribbon text textarea if a ribbon exists in the cart
    if (ribbonTextValue && ribbonTextValue["Ribbon Text"]) {
      elements.ribbonText.value = ribbonTextValue["Ribbon Text"];
      elements.ribbonText.parentElement.querySelector(
        ".gift-option-counter span"
      ).textContent = ribbonTextValue["Ribbon Text"].length;
    }

    // VALENTINES
    if (vdayValue && elements.vdayCheckbox) {
      console.log("vdayValue?", vdayValue);
    }
    // Update the valentines note textarea if it exists in the cart
    if (vdayValue && vdayValue["Vday Note Text"] && elements.vdayNoteText) {
      elements.vdayNoteText.value = vdayValue["Vday Note Text"];
      elements.vdayNoteCount.textContent = vdayValue["Vday Note Text"].length;
    }
    // Update the valentines ribbon textarea if it exists in the cart
    if (vdayValue && vdayValue["Vday Ribbon Text"] && elements.vdayRibbonText) {
      elements.vdayRibbonText.value = vdayValue["Vday Ribbon Text"];
      elements.vdayRibbonCount.textContent =
        vdayValue["Vday Ribbon Text"].length;
    }

    // MD25
    if (md25Value && elements.md25Checkbox) {
      console.log("md25Value?", md25Value);
    }
    // Update the mother's day note textarea if it exists in the cart
    if (
      md25Value &&
      md25Value["Mother's Day Note Text"] &&
      elements.md25NoteText
    ) {
      elements.md25NoteText.value = md25Value["Mother's Day Note Text"];
      elements.md25NoteCount.textContent =
        md25Value["Mother's Day Note Text"].length;
    }
    // Update the mother's day ribbon textarea if it exists in the cart
    if (
      md25Value &&
      md25Value["Mother's Day Ribbon Text"] &&
      elements.md25RibbonText
    ) {
      elements.md25RibbonText.value = md25Value["Mother's Day Ribbon Text"];
      elements.md25RibbonCount.textContent =
        md25Value["Mother's Day Ribbon Text"].length;
    }

    // Set the saved tote design if it exists
    if (md25Value && md25Value["Mother's Day Tote Design"]) {
      const savedToteDesign = document.querySelector(
        `input[name="attributes[md25 tote-design]"][value="${md25Value["Mother's Day Tote Design"]}"]`
      );
      if (savedToteDesign) {
        console.log(
          "🎨 Restoring saved tote design:",
          md25Value["Mother's Day Tote Design"]
        );
        savedToteDesign.checked = true;
      }
    } else {
      const defaultToteDesign = document.querySelector(
        'input[name="attributes[md25 tote-design]"]:checked'
      );
      if (defaultToteDesign) {
        console.log("🎨 Using default tote design:", defaultToteDesign.value);
      }
    }

    // Set the saved ribbon color if it exists
    if (md25Value && md25Value["Mother's Day Ribbon Colour"]) {
      const savedRibbonColor = document.querySelector(
        `input[name="attributes[md25 colour]"][value="${md25Value["Mother's Day Ribbon Colour"]}"]`
      );
      if (savedRibbonColor) {
        console.log(
          "🎀 Restoring saved ribbon color:",
          md25Value["Mother's Day Ribbon Colour"]
        );
        savedRibbonColor.checked = true;
      }
    } else {
      const defaultRibbonColor = document.querySelector(
        'input[name="attributes[md25 colour]"]:checked'
      );
      if (defaultRibbonColor) {
        console.log("🎀 Using default ribbon color:", defaultRibbonColor.value);
      }
    }
  };

  // Initial Setup
  const checkSelectedOptions = async () => {
    try {
      getTextareaContent();
      getGiftboxQuantity();

      // Get the current prices of the gifting options
      notePrice = await getItemPrice(handles.note);
      boxPrice = await getItemPrice(handles.box);
      ribbonPrice = await getItemPrice(handles.ribbon);

      document.getElementById("giftbox-price").textContent = boxPrice;
      document.getElementById("ribbon-price").textContent = ribbonPrice;
    } catch (error) {
      console.error("Error checking selected options: ", error);
    }
  };

  // Event Listeners
  if (elements.giftCheckbox)
    elements.giftCheckbox.addEventListener("change", (event) =>
      updateCartAttributes({ Gift: event.target.checked })
    );
  if (elements.giftboxCheckbox)
    elements.giftboxCheckbox.addEventListener("change", (event) =>
      handleCheckboxChange(event, variantIds.giftBoxId)
    );
  if (elements.ribbonCheckbox) {
    elements.ribbonCheckbox.addEventListener("change", (event) => {
      console.log("ribbon checkbox event", event);
      console.log("Current ribbon colour:", ribbonColour); // Add this line

      switch (ribbonColour) {
        case "Neon green":
          handleRibbonCheckboxChange(event, variantIds.ribbonId);
          break;
        case "Pink":
          handleRibbonCheckboxChange(event, variantIds.ribbonId2);
          break;
        case "Cream":
          handleRibbonCheckboxChange(event, variantIds.ribbonId3);
          break;
        case "Black":
          handleRibbonCheckboxChange(event, variantIds.ribbonId4);
          break;
        default:
          handleRibbonCheckboxChange(event, null);
      }
    });
  }
  if (elements.noteCheckbox)
    elements.noteCheckbox.addEventListener("change", (event) =>
      handleCheckboxChange(event, variantIds.giftNoteId)
    );

  if (elements.giftNoteTextarea)
    elements.giftNoteTextarea.addEventListener("input", handleGiftNoteInput);

  if (elements.ribbonText)
    elements.ribbonText.addEventListener("input", handleRibbonTextInput);

  const ribbonColourRadios = document.querySelectorAll(
    'input[name="attributes[Ribbon colour]"]'
  );
  ribbonColourRadios.forEach((radio) => {
    radio.addEventListener("change", handleRibbonColorChange);
  });

  if (elements.giftboxQuantity)
    elements.giftboxQuantity.addEventListener(
      "change",
      handleGiftboxQuantityChange
    );

  //
  // valentines
  //
  const handleVdayNoteInput = debounce(async (event) => {
    const key = await getItemKey(variantIds.vdayPackageId);
    if (key) await submitProperty(key, "Vday Note Text", event.target.value);
  }, 300);

  const handleVdayRibbonInput = debounce(async (event) => {
    const key = await getItemKey(variantIds.vdayPackageId);
    if (key) await submitProperty(key, "Vday Ribbon Text", event.target.value);
  }, 300);

  // Create a shared update function for all text inputs
  const updateCartProperty = async (variantId, propertyName, value) => {
    console.log(`💾 Saving ${propertyName}:`, value);
    const key = await getItemKey(variantId);
    if (key) {
      await submitProperty(key, propertyName, value);
      console.log(`✅ Saved ${propertyName}`);
    } else {
      console.log(
        `❌ Could not save ${propertyName} - package not found in cart`
      );
    }
  };

  // Create debounced version with shorter delay
  const debouncedUpdateCartProperty = debounce(updateCartProperty, 150);

  // Helper to handle both immediate and debounced updates
  const setupTextInput = (element, variantId, propertyName) => {
    if (!element) return;

    // Handle typing with debounce
    element.addEventListener("input", (event) => {
      debouncedUpdateCartProperty(variantId, propertyName, event.target.value);
    });

    // Handle blur (leaving the input) immediately
    element.addEventListener("blur", (event) => {
      // Cancel any pending debounced calls
      debouncedUpdateCartProperty.cancel();
      // Update immediately
      updateCartProperty(variantId, propertyName, event.target.value);
    });
  };

  if (elements.vdayCheckbox)
    elements.vdayCheckbox.addEventListener("change", (event) =>
      handleCheckboxChange(event, variantIds.vdayPackageId)
    );

  // Set up all text inputs
  setupTextInput(
    elements.vdayNoteText,
    variantIds.vdayPackageId,
    "Vday Note Text"
  );
  setupTextInput(
    elements.vdayRibbonText,
    variantIds.vdayPackageId,
    "Vday Ribbon Text"
  );
  setupTextInput(
    elements.md25NoteText,
    variantIds.md25PackageId,
    "Mother's Day Note Text"
  );
  setupTextInput(
    elements.md25RibbonText,
    variantIds.md25PackageId,
    "Mother's Day Ribbon Text"
  );

  // Add event listeners for increment buttons
  const giftboxDecreaseButton = document.getElementById("giftbox-decrease");
  const giftboxIncreaseButton = document.getElementById("giftbox-increase");

  if (giftboxDecreaseButton)
    giftboxDecreaseButton.addEventListener("click", (event) => {
      event.preventDefault();
      handleGiftboxQuantityIncrement(-1);
    });

  if (giftboxIncreaseButton)
    giftboxIncreaseButton.addEventListener("click", (event) => {
      event.preventDefault();
      handleGiftboxQuantityIncrement(1);
    });

  elements.textareas.forEach((textarea) => {
    textarea.addEventListener("input", updateCounter);
    textarea.addEventListener("input", () => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      textarea.value = textarea.value.replace(emojiRegex, "");
    });
  });
  elements.checkboxes.forEach((checkbox) =>
    checkbox.addEventListener("change", toggleTextareas)
  );

  loadCartAccordions();

  // LOAD: show gifting options and hide loader
  toggleTextareas();
  checkSelectedOptions().finally(() => {
    if (elements.giftingOptions && elements.giftingLoader) {
      elements.giftingOptions.style.display = "block";
      elements.giftingLoader.style.display = "none";
    }
  });

  // //
  // // DEVELOPMENT ONLY
  // //

  // maybe development only
  const getCart = async () => {
    console.log("Fetching cart...");
    const url = `${window.Shopify.routes.root}cart.js`;
    console.log(url);
    return await fetchWithHandling(url, { method: "GET" });
  };

  const clearCart = async () => {
    console.log("Clearing cart...");
    const url = `${window.Shopify.routes.root}cart/clear.js`;
    console.log(url);
    return await fetchWithHandling(url, { method: "POST" });
  };

  // development only
  const handleCartButtonClick = async (event) => {
    event.preventDefault();
    const cart = await getCart();
    console.log("🛒 Cart Object: ", cart); // Logs the entire cart object to the console
  };

  const handleClearButtonClick = async (event) => {
    event.preventDefault();
    const cart = await clearCart();
    console.log(cart); // Logs the entire cart object to the console
    window.location.reload();
  };

  // development only
  const handleShippingButtonClick = async (event) => {
    event.preventDefault();

    console.log("Shipping button clicked");

    // const locale = window.Shopify.locale;
    const zip = "N8+9JP"; // Replace with the actual zip code if available
    const country = window.Shopify.country;
    const province = "London"; // Replace with the actual province if available

    const uri = `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${zip}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`;

    console.log(uri);

    const shipping = await fetchWithHandling(uri, { method: "GET" });
    console.log(shipping); // Logs the entire cart object to the console
  };

  // CART INFO BUTTON
  if (elements.cartButton)
    elements.cartButton.addEventListener("click", handleCartButtonClick);
  if (elements.shipButton)
    elements.shipButton.addEventListener("click", handleShippingButtonClick);
  if (elements.clearButton)
    elements.clearButton.addEventListener("click", handleClearButtonClick);


//
// md25
//

// const handleToteDesignChange = async (event) => {
//   const selectedDesign = event.target.value;
//   console.log("🎨 Tote design changed to:", selectedDesign);
//   const key = await getItemKey(variantIds.md25PackageId);
//   if (key) {
//     console.log("📦 Updating cart with new tote design...");
//     await submitProperty(key, "Mother's Day Tote Design", selectedDesign);
//     console.log("✅ Cart updated with tote design:", selectedDesign);
//   } else {
//     console.log(
//       "❌ Could not update cart - Mother's Day package not found in cart"
//     );
//   }
// };

// const handleMd25RibbonColorChange = async (event) => {
//   const selectedColor = event.target.value;
//   console.log("🎀 Ribbon color changed to:", selectedColor);
//   const key = await getItemKey(variantIds.md25PackageId);
//   if (key) {
//     console.log("📦 Updating cart with new ribbon color...");
//     await submitProperty(key, "Mother's Day Ribbon Colour", selectedColor);
//     console.log("✅ Cart updated with ribbon color:", selectedColor);
//   } else {
//     console.log(
//       "❌ Could not update cart - Mother's Day package not found in cart"
//     );
//   }
// };

// if (elements.md25Checkbox)
//   elements.md25Checkbox.addEventListener("change", async (event) => {
//     await handleCheckboxChange(event, variantIds.md25PackageId);
//     // If checkbox is checked, send the initial selections
//     if (event.target.checked) {
//       console.log("📦 Mother's Day package checkbox checked");

//       // Handle tote design
//       const selectedToteDesign = document.querySelector(
//         'input[name="attributes[md25 tote-design]"]:checked'
//       );
//       if (selectedToteDesign) {
//         console.log(
//           "🎨 Sending initial tote design to cart:",
//           selectedToteDesign.value
//         );
//         const key = await getItemKey(variantIds.md25PackageId);
//         if (key) {
//           await submitProperty(
//             key,
//             "Mother's Day Tote Design",
//             selectedToteDesign.value
//           );
//           console.log("✅ Initial tote design saved to cart");
//         }
//       }

//       // Handle ribbon color
//       const selectedRibbonColor = document.querySelector(
//         'input[name="attributes[md25 colour]"]:checked'
//       );
//       if (selectedRibbonColor) {
//         console.log(
//           "🎀 Sending initial ribbon color to cart:",
//           selectedRibbonColor.value
//         );
//         const key = await getItemKey(variantIds.md25PackageId);
//         if (key) {
//           await submitProperty(
//             key,
//             "Mother's Day Ribbon Colour",
//             selectedRibbonColor.value
//           );
//           console.log("✅ Initial ribbon color saved to cart");
//         }
//       }
//     } else {
//       console.log("📦 Mother's Day package checkbox unchecked");
//     }
//   });

// // Add event listeners to tote design radio inputs
// console.log("🎨 Setting up tote design radio listeners...");
// const toteDesignRadios = document.querySelectorAll(
//   'input[name="attributes[md25 tote-design]"]'
// );
// console.log(`Found ${toteDesignRadios.length} tote design options`);
// toteDesignRadios.forEach((radio) => {
//   radio.addEventListener("change", handleToteDesignChange);
// });

// // Add event listeners to ribbon color radio inputs
// console.log("🎀 Setting up ribbon color radio listeners...");
// const ribbonColorRadios = document.querySelectorAll(
//   'input[name="attributes[md25 colour]"]'
// );
// console.log(`Found ${ribbonColorRadios.length} ribbon color options`);
// ribbonColorRadios.forEach((radio) => {
//   radio.addEventListener("change", handleMd25RibbonColorChange);
// });

// if (elements.md25NoteText)
//   elements.md25NoteText.addEventListener("input", (event) => {
//     // Update counter
//     if (elements.md25NoteCount) {
//       elements.md25NoteCount.textContent = event.target.value.length;
//     }
//     // Handle cart update
//     handleVdayNoteInput(event);
//   });

// if (elements.md25RibbonText)
//   elements.md25RibbonText.addEventListener("input", (event) => {
//     // Update counter
//     if (elements.md25RibbonCount) {
//       elements.md25RibbonCount.textContent = event.target.value.length;
//     }
//     // Handle cart update
//     handleVdayRibbonInput(event);
//   });

//
// fd25
//

if (elements.fd25Checkbox)
  elements.fd25Checkbox.addEventListener("change", async (event) => {
    await handleCheckboxChange(event, variantIds.fd25PackageId);
    // If checkbox is checked, send the initial selections
    if (event.target.checked) {
      console.log("📦 Father's Day patches checkbox checked");
    } else {
      console.log("📦 Father's Day patches checkbox unchecked");
    }
  });
});

